module.exports = __webpack_public_path__ + "static/media/FormCheckbox_Checked.d15aae23.svg";